import React from 'react';
import '../../styles/RateCard.css';

const SpecsBeAdsDektop = () => {
    return (
        <section className="specs-be-ads-section py-5" id='specs'>
            <div className="container">
                <div className='m-0 row justify-content-between align-items-center mb-4'>
                    <div className='col-lg-3 col-md-4 p-0'>
                        <h2 className="title text-white text-capitalize mb-4" data-aos="fade-right" data-aos-delay="200">
                            SPECS<br /><span className="highlight-bg">Be Ads</span>
                        </h2>
                    </div>
                    <div className='col-lg-3 col-md-4 p-3 rounded' data-aos="fade-left" data-aos-delay="200">
                        <h3>Ubicaciones:</h3>
                        <p>Los banners se pueden mostrar en Home, Interiores de preferencia o rotar en todo el sitio (ROS).</p>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-md-9 mt-3' data-aos="fade-right" data-aos-delay="200">
                        <div className="table-responsive">
                            <table className="table table-bordered text-center align-middle custom-table">
                                <thead>
                                    <tr>
                                        <th className='pt-4 pb-4'>Formato</th>
                                        <th className='pt-4 pb-4'>Dimensiones</th>
                                        <th className='pt-4 pb-4'>Admite</th>
                                        <th className='pt-4 pb-4'>Notas</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>FullScreen Banner</td>
                                        <td>1920x1080</td>
                                        <td rowSpan="9">
                                            Imagen: JPG, PNG o GIF.<br />
                                            <br />
                                            Animado: HTML comprimido en carpeta ZIP.<br />
                                            <br />
                                            Tags de 3ros.
                                        </td>
                                        <td rowSpan="9">Los materiales sin compresión deben tener un peso inferior a 1 mb.</td>
                                    </tr>
                                    <tr>
                                        <td>Square Box</td>
                                        <td>300x250</td>
                                    </tr>
                                    <tr>
                                        <td>Big Skyscraper</td>
                                        <td>300x600</td>
                                    </tr>
                                    <tr>
                                        <td>Header Leaderboard</td>
                                        <td>728x90</td>
                                    </tr>
                                    <tr>
                                        <td>Leaderboard</td>
                                        <td>728x90</td>
                                    </tr>
                                    <tr>
                                        <td>Footer Leaderboard</td>
                                        <td>728x90</td>
                                    </tr>
                                    <tr>
                                        <td>Skyscraper</td>
                                        <td>160x600</td>
                                    </tr>
                                    <tr>
                                        <td>Small Skyscraper</td>
                                        <td>120x600</td>
                                    </tr>
                                    <tr>
                                        <td>Billboard</td>
                                        <td>970x250</td>
                                    </tr>
                                    <tr>
                                        <td>Sponsor Take Cover</td>
                                        <td>1920x1080</td>
                                        <td>Archivo editable PSD o AI.</td>
                                        <td>El material a implementar será optimizado por nuestro equipo a partir del original.</td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>
                    <div className='col-md-3 mt-3' data-aos="fade-left" data-aos-delay="200">
                        <div className='d-flex justify-content-center'>
                            <div className='position-relative z-0' style={{ width: '100%' }}>
                                <h3 className="subtitle-rate-card fw-bold text-center w-100 text-white py-2 rounded-top">
                                    Desktop
                                </h3>

                                <div className='position-absolute top-100 start-50 translate-middle'>
                                    <svg width="2em" height="2em" viewBox="0 0 16 16" className="bi bi-caret-down-fill" fill="#439b6b" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                    </svg>
                                </div>
                            </div>
                        </div>

                        <div className='mt-3 rounded pt-5 pb-5 text-center'>
                            <img src="assets/desktop.png" className='img-fluid w-75' alt="" />
                        </div>
                        <div className='text-center text-white fw-bold mt-4'>
                            <p>Ver especificaciones</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SpecsBeAdsDektop;